<template>    
  <div v-if="showtitle == 'true'" class="text-center fw-bold">{{title}}</div>
  <div class="d-flex align-items-center justify-content-center flex-wrap">

    <VueApexCharts
      v-if="!loading"
      ref="hChart"
      type="pie"
      :options="options"
      :series="series"
      class="w-100"
      style="max-width: 400px !important; "
    ></VueApexCharts>
    <div>
      <table style="border-spacing: 0 1em">
        <tr v-for="(item, i) in series" :key="i" style="font-size: 14px">
          <td class="p-1" style="width: 30px; height: 20px">
            <div
              :style="(type !== 'elmix-nordisk' && i == 2) ? 'background-image: linear-gradient(180deg, #47525d 25%, #ffffff 25%, #ffffff 50%, #47525d 50%, #47525d 75%, #ffffff 75%, #ffffff 100%); background-size: 12.00px 12.00px;' + 'color:' +
                    options.colors[i] +
                    ';'
                  : 'background:' +
                    options.colors[i] +
                    '; color:' +
                    options.colors[i] +
                    ';'
              "
              class="h-100 w-100"
            ></div>
          </td>
          <td class="px-2">{{ labelsArray[i] }}</td>
          <td class="text-end">{{ item }}%</td>
        </tr>
      </table>
    </div>
  </div>
  <ComponentStyles></ComponentStyles>
</template>
<script>
import ComponentStyles from "../componentStyles.vue";
import VueApexCharts from "vue3-apexcharts";
export default {
  props: ["type", "showtitle"],
  components: { VueApexCharts, ComponentStyles },
  data() {
    return {
      loading: true,
      labelsArray: [],
      seriesArray: [],
      title: ""
    };
  },
  methods: {
    async fetchData() {
      if (this.type == "elmix") {
        fetch(
          "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/elmix/", { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }
        )
          .then((res) => res.json())
          .then((json) => {
            console.log(json.content.TagContent);
            this.labelsArray = ["Bio", "Vatten", "Vind", "Sol"];
            this.seriesArray = [
              json.content.TagContent.ElmixGEABBio * 1,
              json.content.TagContent.ElmixGEABVatten * 1,
              json.content.TagContent.ElmixGEABVind * 1,
              json.content.TagContent.ElmixGEABSol * 1,
            ];
            this.title = json.content.TagContent.ElmixGEAB
            
          });
      } else if (this.type == "elmix-nordisk") {
        fetch(
          "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/elmix/", { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }
        )
          .then((res) => res.json())
          .then((json) => {
            console.log(json.content.TagContent);
            this.labelsArray = ["Förnybar el", "Fossilt", "Kärnkraft"];
            this.seriesArray = [
              json.content.TagContent.ElmixNordiskFornybart * 1,
              json.content.TagContent.ElmixNordiskFossilt * 1,
              json.content.TagContent.ElmixNordiskKarnkraft * 1,
            ];
            this.title = json.content.TagContent.ElmixNordisk
            this.options.colors = [
         
          "#228a93",
          "#e2c100",
          "#9d46af",
          "#006633",
          "#b17f4a",
          "#235591",
        ],
            this.options.fill.pattern.style = [];
          });
      } else if (this.type == "produktionsmix-fjv") {
        this.seriesArray = [48, 35, 7, 8, 1, 1];
        this.labelsArray = [
          "Restvärme",
          "Sekundära träbränslen",
          "Rökgaskondensering",
          "Returträ",
          "Hjälpel",
          "Bioolja",
        ];
        this.title = "Produktionsmix"
      }

      this.loading = false;
    },
  },

  computed: {
    options: function () {
      return {

        dataLabels: {
          enabled: false,
        },
       

        legend: {
          show: false,
        },

        labels: this.labels,
        colors: [
          "#f28c00",
          "#8fc02f",
          "#47525d",
          "#cd0c4e",
          "#228a93",
          "#e2c100",
          "#9d46af",
          "#006633",
          "#b17f4a",
          "#235591",
        ],
        fill: {
          type: "pattern",
          opacity: 1,
          pattern: {
            enabled: true,
            //eslint-disable-next-line
            style: [, , "horizontalLines"],
            strokeWidth: 6,
          },
        },
        plotOptions: {
          pie: {
            show: true,
            dataLabels: {
        offset: 0,
        minAngleToShowLabel: 0
    }, 
          },
        },
        tooltip: {
          enabled: true,

          y:{
            formatter: function (val) {
            return val + "%";
          },
          }
          
        },
      };
    },

    series: function () {
      return this.seriesArray;
    },
    labels: function () {
      return this.labelsArray;
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>
